export default __webpack_public_path__ + "static/media/business-problem2.5d2c073e.gif";